import type { Currency } from '../constants/currencies';

export interface Translation {
    language?: string;
    name?: string;
    description: string;
}

export const PLANS = ['starter', 'growth', 'pro', 'enterprise'] as const;
export type Plan = (typeof PLANS)[number];

export type PlanLimitKey = 'locations' | 'users' | 'languages';

/** A null limit means unlimited. */
export interface PlanUsage {
    plan: Plan;
    trialEndsAt: string | null;
    limits: Record<PlanLimitKey, number | null>;
    usage: Record<PlanLimitKey, number>;
}

export interface Restaurant {
    id: string;
    name: string;
    description?: string | null;
    supportedLanguages: string[];
    translations: Translation[];
    logoUrl: string | null;
    /** IANA zone; statistics and statements cut their days and months in it. */
    timezone: string;
    currency: Currency;
    plan: Plan;
    trialEndsAt: string | null;
}
